const PROMO_SESSION_KEY = 'wla-app-promo-seed-v1';
const EVENT_ENDPOINT = '/api/events';
const APP_PROMO_EXPERIMENT = 'ios-app-growth-v1';

const COPY = {
  da: [
    ['Alt Apple. Ét hurtigt overblik.', 'Nyheder, guides, rygter og beta-nyt samlet på iPhone og iPad.', 1],
    ['Dit eget Apple-feed', 'Vælg dine interesser, og få et personligt “For dig”-feed.', 1],
    ['Se hvad andre læser nu', '“Mest læste” fører dig direkte til dagens populære historier.', 5],
    ['Find den bedste Apple-pris', 'Sammenlign aktuelle priser og tilbud i den nye Prisguide.', 3],
    ['Køb nu – eller vent?', 'Få prisoverblik og hjælp til at vurdere det rigtige købstidspunkt.', 3],
    ['Gå aldrig glip af en Apple-dato', 'Events, lanceringer og vigtige milepæle samlet i kalenderen.', 4],
    ['Få artiklen kort fortalt', 'Bed om et AI-resumé, når du vil have hovedpunkterne hurtigt.', 2],
    ['Lyt i stedet for at læse', 'Start AI-oplæsning af en artikel, når det passer dig.', 2],
    ['Gem den til senere', 'Saml artikler i “Læs senere”, og vend tilbage i ro og mag.', 5],
    ['Hold styr på det læste', 'Markér historier som læst eller ulæst på tværs af dit feed.', 5],
    ['Læs på din måde', 'Tilpas tekststørrelse og linjeafstand til dine øjne.', 2],
    ['Kun teksten. Ingen støj.', 'Skift til “kun tekst”, når du vil have maksimal læsero.', 2],
    ['Lys, mørk eller automatisk', 'Vælg tema selv, eller lad appen følge din enhed.', 1],
    ['Vigtige Apple-nyheder med det samme', 'Slå push til, og få besked når en historie virkelig betyder noget.', 5],
    ['Apple-nyt direkte på hjemmeskærmen', 'Åbn de seneste historier hurtigt fra appens widget.', 5],
    ['Dansk og svensk i samme app', 'Skift feed og sprog, når du vil følge Apple på begge sprog.', 1],
    ['Bygget til både iPhone og iPad', 'Et responsivt layout udnytter skærmen på begge enheder.', 1],
    ['Følg produkterne du overvejer', 'Saml prisoverblik og tilbud på de Apple-produkter, der interesserer dig.', 3],
    ['Fra iPhone til Vision og Apple TV', 'Følg hele Apple-universet uden at hoppe mellem tjenester.', 1],
    ['Version 1.0.6 er landet', 'Svensk feed, Prisguide, Apple-kalender og AI-værktøjer i én stor opdatering.', 4]
  ],
  sv: [
    ['Allt om Apple. En snabb överblick.', 'Nyheter, guider, rykten och betanytt samlat på iPhone och iPad.', 1],
    ['Ditt eget Apple-flöde', 'Välj dina intressen och få ett personligt ”För dig”-flöde.', 1],
    ['Se vad andra läser just nu', '”Mest lästa” leder dig direkt till dagens populära artiklar.', 5],
    ['Hitta bästa Apple-priset', 'Jämför aktuella priser och erbjudanden i den nya Prisguiden.', 3],
    ['Köpa nu – eller vänta?', 'Få prisöverblick och hjälp att bedöma rätt köptillfälle.', 3],
    ['Missa aldrig ett Apple-datum', 'Event, lanseringar och viktiga milstolpar samlade i kalendern.', 4],
    ['Få artikeln kort sammanfattad', 'Be om en AI-sammanfattning när du snabbt vill ha huvudpunkterna.', 2],
    ['Lyssna i stället för att läsa', 'Starta AI-uppläsning av en artikel när det passar dig.', 2],
    ['Spara den till senare', 'Samla artiklar i ”Läs senare” och återvänd när du har tid.', 5],
    ['Håll koll på det du läst', 'Markera artiklar som lästa eller olästa i ditt flöde.', 5],
    ['Läs på ditt sätt', 'Anpassa textstorlek och radavstånd efter dina behov.', 2],
    ['Bara texten. Inget brus.', 'Växla till ”endast text” när du vill läsa med fullt fokus.', 2],
    ['Ljust, mörkt eller automatiskt', 'Välj tema själv eller låt appen följa din enhet.', 1],
    ['Viktiga Apple-nyheter direkt', 'Slå på push och få besked när en artikel verkligen spelar roll.', 5],
    ['Apple-nytt på hemskärmen', 'Öppna de senaste artiklarna snabbt från appens widget.', 5],
    ['Danska och svenska i samma app', 'Byt flöde och språk när du vill följa Apple på båda språken.', 1],
    ['Byggd för både iPhone och iPad', 'En responsiv layout utnyttjar skärmen på båda enheterna.', 1],
    ['Följ produkterna du överväger', 'Samla priser och erbjudanden för de Apple-produkter som intresserar dig.', 3],
    ['Från iPhone till Vision och Apple TV', 'Följ hela Apple-världen utan att hoppa mellan tjänster.', 1],
    ['Version 1.0.6 är här', 'Svenskt flöde, Prisguide, Apple-kalender och AI-verktyg i en stor uppdatering.', 4]
  ]
};

function sessionSeed() {
  try {
    let seed = sessionStorage.getItem(PROMO_SESSION_KEY);
    if (!seed) {
      seed = String(Math.random());
      sessionStorage.setItem(PROMO_SESSION_KEY, seed);
    }
    return seed;
  } catch (_) { return String(Math.random()); }
}

function hashFor(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  return hash;
}

function indexFor(surface, count) {
  return hashFor(`${sessionSeed()}:${surface}:${location.pathname}`) % count;
}

export function isAppleMobileDevice({
  userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent,
  platform = typeof navigator === 'undefined' ? '' : navigator.platform,
  maxTouchPoints = typeof navigator === 'undefined' ? 0 : navigator.maxTouchPoints
} = {}) {
  return /iPhone|iPad|iPod/i.test(String(userAgent || '')) ||
    (String(platform || '') === 'MacIntel' && Number(maxTouchPoints || 0) > 1);
}

function deviceKind() {
  if (/iPhone|iPod/i.test(navigator.userAgent || '')) return 'iphone';
  return 'ipad';
}

export function appStoreCampaignUrl(baseUrl, providerToken = '', campaignToken = '') {
  const url = new URL(baseUrl);
  if (providerToken && !url.searchParams.has('pt')) url.searchParams.set('pt', providerToken);
  if (campaignToken && !url.searchParams.has('ct')) url.searchParams.set('ct', campaignToken);
  if (!url.searchParams.has('mt')) url.searchParams.set('mt', '8');
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach((key) => url.searchParams.delete(key));
  return url;
}

function eventPayload(eventName, promo, meta = {}) {
  return {
    eventName,
    experimentKey: APP_PROMO_EXPERIMENT,
    variantKey: `copy-${promo.dataset.wlaAppPromoVariant || '1'}`,
    surface: promo.dataset.wlaAppPromoSurface || 'article',
    placement: promo.dataset.wlaAppPromoSurface || 'article',
    pagePath: `${window.location.pathname}${window.location.search}`,
    pageUrl: window.location.href,
    value: 0,
    meta: {
      device: deviceKind(),
      campaignToken: promo.dataset.wlaAppPromoCampaign || '',
      ...meta
    }
  };
}

function sendAppPromoEvent(eventName, promo, meta = {}) {
  if (!promo) return;
  const payload = eventPayload(eventName, promo, meta);
  const analyticsPayload = {
    event: `wla_${eventName}`,
    app_promo_surface: payload.surface,
    app_promo_campaign: payload.meta.campaignToken,
    app_promo_variant: payload.variantKey,
    app_promo_device: payload.meta.device
  };

  if (typeof window.gtag === 'function') {
    window.gtag('event', `wla_${eventName}`, analyticsPayload);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(analyticsPayload);

  try {
    const body = JSON.stringify(payload);
    if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(EVENT_ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
    fetch(EVENT_ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
      keepalive: true
    }).catch(() => {});
  } catch {}
}

function trackPromo(promo) {
  if (!promo || promo.dataset.wlaAppPromoTracked === 'true') return;
  promo.dataset.wlaAppPromoTracked = 'true';
  promo.addEventListener('click', () => sendAppPromoEvent('app_promo_click', promo));

  const sendImpression = (ratio = 1) => {
    if (promo.dataset.wlaAppPromoImpressionSent === 'true') return;
    promo.dataset.wlaAppPromoImpressionSent = 'true';
    sendAppPromoEvent('app_promo_impression', promo, { intersectionRatio: Math.round(ratio * 100) / 100 });
  };

  if (!('IntersectionObserver' in window)) {
    sendImpression();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
      sendImpression(entry.intersectionRatio);
      observer.disconnect();
    });
  }, { threshold: [0.35] });
  observer.observe(promo);
}

function promoMarkup(config, surface, campaign = {}) {
  const locale = config.dataset.locale === 'sv' ? 'sv' : 'da';
  const configured = campaign.locales?.[locale]?.messages;
  const variants = Array.isArray(configured) && configured.length ? configured.map((item, index) => [item.title, item.text, item.screen || ((index % 5) + 1)]) : COPY[locale];
  const variantIndex = indexFor(surface, variants.length);
  const [title, text, screen] = variants[variantIndex];
  const install = locale === 'sv' ? 'Hämta appen' : 'Hent appen';
  const eyebrow = locale === 'sv' ? 'WeLoveApple för iOS' : 'WeLoveApple til iOS';
  const devices = locale === 'sv' ? 'För iPhone och iPad' : 'Til iPhone og iPad';
  const badgeAlt = locale === 'sv' ? 'Hämta i App Store' : 'Hent i App Store';
  const url = appStoreCampaignUrl(
    campaign.appStoreUrl || config.dataset.appStoreUrl,
    config.dataset.providerToken,
    config.dataset.campaignToken
  );
  const campaignToken = url.searchParams.get('ct') || config.dataset.campaignToken || '';

  return `<a class="wla-app-promo wla-app-promo--${surface}" href="${url}" target="_blank" rel="noopener noreferrer" data-wla-app-promo data-wla-app-promo-surface="${surface}" data-wla-app-promo-campaign="${campaignToken}" data-wla-app-promo-variant="${variantIndex + 1}" aria-label="${install}: ${title}">
    <span class="wla-app-promo__copy">
      <span class="wla-app-promo__brand"><img src="${config.dataset.appIcon}" alt="" width="48" height="48"><span>${eyebrow}</span></span>
      <strong>${title}</strong><span class="wla-app-promo__text">${text}</span>
      <span class="wla-app-promo__action"><img class="wla-app-promo__badge" src="${config.dataset.appStoreBadge}" alt="${badgeAlt}" width="120" height="40"><span>${devices}</span></span>
    </span>
    <img class="wla-app-promo__screen" src="${config.getAttribute(`data-screen-${screen}`)}" alt="" loading="lazy" width="332" height="720">
  </a>`;
}

function mount(host, config, surface, campaign) {
  if (!host || host.dataset.wlaAppPromoMounted === 'true') return;
  host.dataset.wlaAppPromoMounted = 'true';
  host.innerHTML = promoMarkup(config, surface, campaign);
  trackPromo(host.querySelector('[data-wla-app-promo]'));
}

export function initAppInstallPromos(remoteCampaign = null) {
  const config = document.querySelector('[data-wla-app-promo-config]');
  if (!config) return;
  if (!isAppleMobileDevice()) return;
  document.documentElement.classList.add('wla-apple-mobile');
  const locale = config.dataset.locale === 'sv' ? 'sv' : 'da';
  const campaign = remoteCampaign || { status: 'active', ratioNumerator: 1, ratioDenominator: 3, locales: { da: { active: true }, sv: { active: false } } };
  if (campaign.status !== 'active' || campaign.locales?.[locale]?.active === false) return;

  const existing = document.querySelector('.post-content .wla-app-cta');
  if (existing) {
    existing.className = 'wla-app-promo-host wla-app-promo-host--inline';
    existing.removeAttribute('style');
    mount(existing, config, 'inline', campaign);
  }
}
